import React, {} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

import './TicketInfo.css';

import Ticket from '../Ticket/Ticket'; 
import TicketMessages from '../TicketMessages/TicketMessages';

const TicketInfo = (props) => {
    const { user, usersSAT, ticket, setTicket, textoRes, setTextoRes, adjuntoRes, setAdjuntoRes, flagAdjuntoRes, setFlagAdjuntoRes, setFlagTextoRes, setBodyUptTicket } = props

    return(
        <div className = 'container-fluid' style={{marginTop: "40px"}}>
            <div className = 'row ticket-info-row'>
                <div className = 'col-3 ticket-info-sidebar' style={{border: "1px solid #000", marginRight: "20px"}}>
                    <Ticket user = {user} usersSAT = {usersSAT} ticket = {ticket} setTicket = {setTicket} setBodyUptTicket = {setBodyUptTicket}/>
                </div>
                <div className = 'col ticket-info-content' style={{border: "1px solid #000"}}>
                    <TicketMessages user = {user} ticket = {ticket} setTicket = {setTicket} textoRes = {textoRes} setTextoRes = {setTextoRes} adjuntoRes = {adjuntoRes} setAdjuntoRes = {setAdjuntoRes} flagAdjuntoRes={flagAdjuntoRes} setFlagAdjuntoRes={setFlagAdjuntoRes} setFlagTextoRes={setFlagTextoRes}/>
                </div>
            </div>
        </div>
    )
}

export default TicketInfo;
